module.exports = __webpack_public_path__ + "static/bombilla1-9b1873831c4a0dc6d28e57589e933faf.jpg";